module.exports = __webpack_public_path__ + "static/media/phone-credit card-money-finance.7d171d90.svg";